import Phaser from 'phaser'
import { buildings } from '../components/buildings';

export default class Game extends Phaser.Scene {
    constructor() {
        super('game')
    }

    init(data) {
        this.isDead = false;
        this.isJumping = false;
        this.directionLeft = true;
        this.score = 0;
        this.steps = 0;
        this.lastFloor = null;
        this.buildings = buildings;
        this.minDegree = -40;
        this.maxDegree = -120;
        this.isMute = false;
    }

    create() {
        let self = this;
        this.leftBadCount = 1;
        this.rightBadCount = 1;

        //Sounds
        this.bgm = this.sound.add('bgm', { loop: true });
        this.bgm.play();

        this.pointSfx = this.sound.add('pointSfx');
        this.hitSfx = this.sound.add('hitSfx');

        //create background
        this.add.image(400, 800, 'bg', 'BG-ingame');

        this.cat = this.physics.add.sprite(400, 500, 'cat')
            .setDepth(1)
            .setBodySize(0.1, 0.1);
        this.cat.play('cat-idle');
        this.cat.body.setAllowGravity(false);

        //Cat boundary
        this.cat.setCollideWorldBounds(true);
        this.cat.body.setBoundsRectangle(new Phaser.Geom.Rectangle(0, 450, 800, 1030)); //Cat bounds to world environment 

        //Create animations
        this.createAnimations();

        this.arrow = this.add.sprite(400, 500, 'arrow')
            .setDepth(3);
        this.arrowRight = this.add.sprite(400, 500, 'arrowR')
            .setVisible(false)
            .setDepth(3);

        this.leftBuilding = this.physics.add.staticGroup();
        this.rightBuilding = this.physics.add.staticGroup();
        //Add tween to rotate arrow or aim
        this.arrowTween = this.tweens.addCounter({
            from: this.minDegree,
            to: this.maxDegree,
            duration: 1000,
            repeat: -1,
            yoyo: true,
            ease: 'power4',
            onUpdate: function(tween) {
                self.arrow.setAngle(tween.getValue());
                self.arrowRight.setAngle(tween.getValue());
            }
        });

        this.initBuildings();
        this.initHUD();

        //Add on pointer down event
        this.input.on('pointerdown', function(pointer) {
            var touchY = pointer.y;
            if (!self.isJumping && touchY > 300) {
                self.isJumping = true;
                self.arrow.setVisible(false);
                self.arrowRight.setVisible(false);
                if (touchY > 200) {
                    if (self.directionLeft)
                        self.physics.velocityFromAngle(self.arrow.angle - 130, 1000, self.cat.body.velocity);
                    else
                        self.physics.velocityFromAngle(180 + (self.arrow.angle - 130), 1000, self.cat.body.velocity);
                }
                self.cat.play('cat-jump');
            }
        }, this);

        this.timedEvent = this.time.addEvent({
            delay: 2000,
            callback: function() {
                self.spawnObstacle();
            },
            callbackScope: this,
            loop: true
        });
    }

    createAnimations() {
        //cat animations
        this.anims.create({
            key: 'cat-idle',
            frames: this.anims.generateFrameNames('cat', { prefix: 'cat_idle_', start: 1, end: 2 }),
            frameRate: 1,
            repeat: -1
        });

        this.anims.create({
            key: 'cat-jump',
            frames: this.anims.generateFrameNames('cat', { prefix: 'cat_jump_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        //normal floor
        this.anims.create({
            key: 'normal',
            frames: this.anims.generateFrameNames('destination', { prefix: 'empty_', start: 1, end: 1 }),
            frameRate: 1,
            repeat: -1
        });

        //Bad Guy animations
        this.anims.create({
            key: 'bad-idle',
            frames: this.anims.generateFrameNames('destination', { prefix: 'guy_idle_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        this.anims.create({
            key: 'bad-hit',
            frames: this.anims.generateFrameNames('destination', { prefix: 'guy_hit_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        //Good Girl animations
        this.anims.create({
            key: 'good-idle',
            frames: this.anims.generateFrameNames('destination', { prefix: 'girl_idle_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        this.anims.create({
            key: 'good-hit',
            frames: this.anims.generateFrameNames('destination', { prefix: 'girl_hit_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        //birds
        this.anims.create({
            key: 'bird-1',
            frames: this.anims.generateFrameNames('birds', { prefix: 'bird_brown_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        this.anims.create({
            key: 'bird-2',
            frames: this.anims.generateFrameNames('birds', { prefix: 'bird_blue_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        this.anims.create({
            key: 'bird-3',
            frames: this.anims.generateFrameNames('birds', { prefix: 'bird_white_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        this.anims.create({
            key: 'bird-4',
            frames: this.anims.generateFrameNames('birds', { prefix: 'bird_yellow_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        //Balloons
        this.anims.create({
            key: 'balloon-1',
            frames: this.anims.generateFrameNames('balloons', { prefix: 'balloon_blue_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        this.anims.create({
            key: 'balloon-2',
            frames: this.anims.generateFrameNames('balloons', { prefix: 'balloon_orange_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

        this.anims.create({
            key: 'balloon-3',
            frames: this.anims.generateFrameNames('balloons', { prefix: 'balloon_red_', start: 1, end: 2 }),
            frameRate: 4,
            repeat: -1
        });

    }

    //Initialize buildings
    initBuildings() {
        var self = this;
        let botPos = 1400;
        let leftPos = 100;
        let rightPos = 700;

        this.leftIterate = [0, 0, 0, 0, 1, 2];
        this.rightIterate = [0, 0, 0, 0, 1, 2];

        this.shuffle(this.buildings.leftFloors);
        this.shuffle(this.buildings.rightFloors);

        this.floorColors = [2, 3, 4, 5, 6, 7];
        this.shuffle(this.floorColors);

        // The floors/rooms in each buildings. Use this to change the room visual
        this.rightFloors = this.add.group();
        this.leftFloors = this.add.group();

        // The occupants in each building. Use this sprites to animate each occupant
        this.leftOccupant = [];
        this.rightOccupant = [];

        //create basic buildings
        this.add.sprite(leftPos, botPos + 180, 'floor');
        this.add.sprite(rightPos, botPos + 180, 'floor').setFlipX(true);
        for (var i = 0; i < this.buildings.default.length; i++) {
            let yPos = botPos - (i * 180);


            this.rightFloors.create(rightPos, yPos, 'floor', 'apartment_' + this.floorColors[i]);
            this.leftFloors.create(leftPos, yPos, 'floor', 'apartment_' + this.floorColors[i]);

            let rightFloor = this.rightBuilding.create(rightPos, yPos, 'destination', 'empty_1');
            rightFloor.setSize(80, 180)
                .setData('index', i)
                .setData('landPosX', rightPos - 60)
                .setData('landPosY', yPos + 10)
                .setData('type', this.buildings.rightFloors[i])
                .setData('variant', 1);

            let leftFloor = this.leftBuilding.create(leftPos, yPos, 'destination', 'empty_1');
            leftFloor.setSize(80, 180)
                .setData('index', i)
                .setData('landPosX', leftPos + 60)
                .setData('landPosY', yPos + 10)
                .setData('type', this.buildings.leftFloors[i])
                .setData('variant', 1);

            if (this.buildings.rightFloors[i] == 0) {
                let floors = this.rightBuilding.getChildren();
                this.initCatDirection(floors[i].getData('landPosX'), floors[i].getData('landPosY'));
                this.changePeakDegree(i);
            }

            let leftOccupant = this.add.sprite(leftPos, yPos, 'destination', 'normal_1').setDepth(2);
            let rightOccupant = this.add.sprite(rightPos, yPos, 'destination', 'normal_1').setFlipX(true).setDepth(2);

            this.leftOccupant.push(leftOccupant);
            this.rightOccupant.push(rightOccupant);

            rightOccupant.play(this.buildings.types[this.buildings.rightFloors[i]]);
            leftOccupant.play(this.buildings.types[this.buildings.leftFloors[i]]);

            let foreground = this.add.sprite(400, 1550, 'bg', 'BG-foreground');
            foreground.setDepth(2);
        }
        //Add roof and lower level
        this.add.sprite(leftPos - 5, botPos - (180 * 5) - 35, 'roof');
        this.add.sprite(rightPos + 5, botPos - (180 * 5) - 35, 'roof').setFlipX(true);


        //flip right building
        this.rightBuilding.children.each(function(floor) {
            floor.setFlipX(true);
        }, this);
        this.rightFloors.children.each(function(floor) {
            floor.setFlipX(true);
        }, this);

        //add collision event between cat and left building
        this.physics.add.collider(this.cat, this.leftBuilding, function(_cat, _floor) {
            if (self.directionLeft) {
                self.landCat(false, _floor);
            }
        });

        //add collision event between cat and right building
        this.physics.add.collider(this.cat, this.rightBuilding, function(_cat, _floor) {
            if (!self.directionLeft) {
                self.landCat(true, _floor);
            }
        });

        this.obstacle = this.physics.add.group();

        this.physics.add.overlap(
            this.cat,
            this.obstacle,
            this.hit,
            null,
            this
        );

    }

    //Initialize Head Up display
    initHUD() {
        let self = this;
        //score font config
        let tconfig = { style: { fontSize: "150px", fontFamily: "dongle", color: "#e3242b", align: 'center' } };

        let board = this.add.image(400, 200, 'ui', 'gameplay-score-box').setDepth(3);

        //Lifepoint
        this.lifePoint = this.add.sprite(0, 0, 'ui', 'life-point').setDepth(4);
        Phaser.Display.Align.In.Center(this.lifePoint, board, 0, 70);

        //add score field
        this.scoreField = this.addText(0, 0, this.score.toString(), tconfig).setDepth(4);
        Phaser.Display.Align.In.Center(this.scoreField, board, 0, 0);

        this.pausebutton = this.add.image(60, 60, 'ui', 'pause-button');
        this.pausebutton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            self.pausebutton.setScale(1);
            self.pause();
        });
        this.pausebutton.on('pointerover', function() {
            self.pausebutton.setScale(1.2);
        });
        this.pausebutton.on('pointerout', function() {
            self.pausebutton.setScale(1);
        });

        this.muteButton = this.add.image(740, 60, 'ui', 'unmute-button').setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            self.mute();
        });
    }

    mute() {
        if (this.isMute) {

            this.muteButton.setTexture('ui', 'unmute-button');

        } else {
            this.muteButton.setTexture('ui', 'mute-button');
        }
        this.sound.mute = !this.isMute;
        this.isMute = !this.isMute;
    }

    //Add text in general
    addText(x, y, str, tconfig) {
        let t = this.make.text(tconfig);
        t.setOrigin(0);
        t.x = x;
        t.y = y;
        t.text = str;
        return t;
    }

    //Set cat world position and facing direction
    setCatDirection(facingLeft, posX, posY) {
        this.cat.body.velocity.x = 0;
        this.cat.body.velocity.y = 0;
        this.cat.setPosition(posX, posY);
        this.cat.play('cat-idle');
        this.cat.setFlipX(!facingLeft);
    }

    //Check where the cat lands
    landCat(facingLeft, floor) {
        var self = this;

        var floorType = floor.getData('type');
        var posX = floor.getData('landPosX');
        var posY = floor.getData('landPosY');
        var floorIndex = floor.getData('index');
        var floorVariant = floor.getData('variant');
        var occupant = this.rightOccupant;

        if (facingLeft) {
            occupant = this.rightOccupant;
        } else
            occupant = this.leftOccupant;

        this.lastFloor = floor;
        this.directionLeft = facingLeft;

        if (floorType == 1) {
            this.increaseScore();
            this.setCatDirection(facingLeft, posX, posY);
            //floor.setTexture('good-land');
            occupant[floorIndex].play('good-hit');
            this.pointSfx.play();
            this.cat.setVisible(false);
            this.decreaseBadGuy(facingLeft);
            floor.setData('type', 0);
            setTimeout(() => {
                self.enableInput(floor);
                occupant[floorIndex].play('normal');
            }, 1000);
            this.randomBuilding(facingLeft);
            this.steps = 0;

        } else if (floorType == 2) {
            //floor.setTexture('bad-land');
            occupant[floorIndex].play('bad-hit');
            this.hitSfx.play();
            this.setCatDirection(facingLeft, posX, posY);
            this.cat.setVisible(false);
            setTimeout(() => {
                self.gameOver(self.score);
            }, 1000);
        } else {
            //normal floor
            this.setCatDirection(facingLeft, posX, posY);
            this.enableInput(floor);
            this.increaseBadGuy(facingLeft);
            this.resetSteps(facingLeft);
        }
        this.changePeakDegree(floorIndex);
    }

    //Increase and update score display
    increaseScore() {
        this.score++;
        console.log("score: " + this.score);
        //update score display
        this.scoreField.text = this.score.toString();
    }

    enableInput(floor) {
        //floor.setTexture(null);
        this.cat.setVisible(true);
        this.isJumping = false;

        this.arrow.setPosition(this.cat.x, this.cat.y);
        this.arrow.setVisible(this.directionLeft);

        this.arrowRight.setPosition(this.cat.x, this.cat.y);
        this.arrowRight.setVisible(!this.directionLeft);

    }

    //Set cat position and re-enable trajectory
    initCatDirection(x, y) {
        this.isJumping = false;

        this.cat.body.velocity.x = 0;
        this.cat.body.velocity.y = 0;
        this.cat.setPosition(x, y);
        this.cat.play('cat-idle');
        this.cat.setFlipX(!this.directionLeft);

        this.arrow.setPosition(this.cat.x, this.cat.y);
        this.arrow.setVisible(this.directionLeft);
        this.arrowRight.setPosition(this.cat.x, this.cat.y);
        this.arrowRight.setVisible(!this.directionLeft);
    }

    addScore(point) {
        this.score += point;
    }

    shuffle(array) {
        let currentIndex = array.length,
            randomIndex;

        // While there remain elements to shuffle.
        while (currentIndex != 0) {

            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]
            ];
        }

        return array;
    }

    // Randomize bad,good and normal floor
    randomBuilding(faceLeft) {
        var floors = null;
        var iterate = this.leftIterate;

        if (faceLeft) {
            floors = this.leftBuilding.getChildren();
            iterate = this.leftIterate;
        } else {
            floors = this.rightBuilding.getChildren();
            iterate = this.rightIterate;
        }

        this.shuffle(iterate);
        for (var i = 0; i < this.buildings.default.length; i++) {
            floors[i].setData('type', iterate[i]);
            if (faceLeft)
                this.leftOccupant[i].play(this.buildings.types[this.leftIterate[i]]);
            else
                this.rightOccupant[i].play(this.buildings.types[this.rightIterate[i]]);
            //TODO: Change each room/floor visual
        }
    }

    pause() {
        this.sound.pauseAll();
        this.scene.pause();
        this.scene.launch('pausemenu');
    }


    resetSteps(faceLeft) {
        this.randomBuilding(faceLeft);
        this.steps = 0;

    }

    //when two objects collides
    hit() {
        this.gameOver(this.score);
    }

    //Spawn floating obstacle or falling obstacle
    spawnObstacle() {
        let xAxis = Math.floor(Math.random() * 200) + 300;
        let typeSpawn = Math.floor(Math.random() * 3);

        if (typeSpawn > 1) {
            // create and drop bomb 1/2 of the time
            this.spawnBird(xAxis);
        } else {
            // create and drop an valuables 1/2 of the time
            this.spawnBalloon(xAxis);
        }
    }

    //
    gameOver(score) {
        this.bgm.stop();
        this.scene.pause();
        this.scene.launch("gameover", { score: score });
        //Todo, implement gameover scene
    }

    spawnBird(xAxis) {
        var newBird = this.obstacle.create(xAxis, -100, 'birds').setCircle(30, 12, 60);
        newBird.play('bird-' + (Math.floor(Math.random() * 4) + 1));
        this.tweens.add({
            targets: newBird,
            y: 1700,
            duration: 3000,
            onComplete: function() { newBird.destroy() },
        });
    }

    spawnBalloon(xAxis) {
        var newBalloon = this.obstacle.create(xAxis, 1700, 'balloons').setCircle(30, 8, 10);
        newBalloon.play('balloon-' + (Math.floor(Math.random() * 3) + 1));
        this.tweens.add({
            targets: newBalloon,
            y: -100,
            duration: 3000,
            onComplete: function() { newBalloon.destroy() },
        });
    }

    increaseBadGuy(faceLeft) {
        for (var i = 0; i < this.buildings.default.length; i++) {
            if (faceLeft) {
                if (this.leftIterate[i] == 0) {
                    this.leftIterate[i] = 2;
                    this.leftBadCount++;
                    break;
                }

            } else {
                if (this.rightIterate[i] == 0) {
                    this.rightIterate[i] = 2;
                    this.rightBadCount++;
                    break;
                }
            }
            break;
        }
    }

    decreaseBadGuy(faceLeft) {
        for (var i = 0; i < this.buildings.default.length; i++) {
            if (faceLeft) {
                if (this.leftIterate[i] == 2 && this.leftBadCount > 1) {
                    this.leftIterate[i] = 0;
                    this.leftBadCount--;
                    break;
                }

            } else {
                if (this.rightIterate[i] == 2 && this.rightBadCount > 1) {
                    this.rightIterate[i] = 0;
                    this.rightBadCount--;
                    break;
                }
            }
        }
    }

    //Change trajectory peak degree
    changePeakDegree(index) {
        var self = this;
        if (this.directionLeft) {
            self.setPeak(20 - (index * 10), -50 - (index * 10));
        } else {
            self.setPeak(-20 + (index * 10), -110 + (index * 10));
        }
        //Add tween to rotate arrow or aim
        this.arrowTween.removeAllListeners();
        this.arrowTween = this.tweens.addCounter({
            from: this.minDegree,
            to: this.maxDegree,
            duration: 1500,
            repeat: -1,
            yoyo: true,
            onUpdate: function(tween) {
                self.arrow.setAngle(tween.getValue());
                self.arrowRight.setAngle(tween.getValue());
            }
        });
    }

    setPeak(top, bot) {
        this.maxDegree = bot;
        this.minDegree = top;
    }
}